import React from 'react';
import { BasicButton, Scrollbar } from '../../UI';
import { getPrimary, getSecondary } from '../../styles/colors';
import FormRootLayout from './FormRootLayout';
import Main from '../../template/Main';
import BlockTitle from '../../UI/BlockTitle';


const ConfigModel = ({
	portal,
	updateState,
	translate
}) => {
	const [close, setClose] = React.useState(false);
	const [localState, setLocalState] = React.useState(portal);

	function changeShowInHome(attachmentsArray) {
		const attachmentsModified = [];
		Object(attachmentsArray).forEach(element => {
			element = { ...element, showInHome: !element.showInHome };
			attachmentsModified.push(element);
		});
		return attachmentsModified;
	}

	const renderForm = React.useCallback(() => (
		<Scrollbar>
			<div style={{
				marginTop: '1em', height: 'calc(100% - 1em)', display: 'flex', gap: '0.8rem', paddingRight: '1rem'
			}}>
				<div style={{
					minWidth: '280px',
					display: 'flex',
					flexDirection: 'column',
					gap: '4px',
				}}>
					{/* HEADER */}
					<BlockTitle text='Header' />
					<BasicButton
						backgroundColor={{
							background: localState.config.header.logoIsActive ? getPrimary() : undefined,
							color: localState.config.header.logoIsActive ? 'white' : 'black',
						}}
						onClick={() => setLocalState({
							...localState,
							config: {
								...localState.config,
								header: {
									...localState.config.header,
									logoIsActive: !localState.config.header.logoIsActive
								}
							}
						})}
						text={`${localState.config.header.logoIsActive ? 'Desactivar' : 'Activar'} logo`}
					/>
					{/* HOME */}

					<BlockTitle text='Home' />
					{localState.config.home
						&& Object.keys(localState.config.home)
							.filter(key => ![null, undefined].includes(localState.config.home[key]?.isActive))
							.map(key => <BasicButton
								key={key}
								backgroundColor={{
									background: localState.config.home[key]?.isActive ? getPrimary() : undefined,
									color: localState.config.home[key]?.isActive ? 'white' : 'black',
								}}
								onClick={() => setLocalState({
									...localState,
									config: {
										...localState.config,
										home: {
											...localState.config.home,
											[key]: {
												...localState.config.home[key],
												isActive: !localState.config.home[key]?.isActive
											}
										}
									}
								})}
								text={`${localState.config.home[key]?.isActive ? 'Desactivar' : 'Activar'} ${key}`}
							/>)
					}
					<BasicButton
						backgroundColor={{
							background: localState.attachments[0]?.showInHome ? getPrimary() : undefined,
							color: localState.attachments[0]?.showInHome ? 'white' : 'black',
						}}

						onClick={() => setLocalState({
							...localState,
							attachments: changeShowInHome(localState.attachments),
						})}
						text={`${localState?.attachments[0]?.showInHome ? 'Desactivar' : 'Activar'} attachments`}
					/>
					{/* FOOTER */}
					<BlockTitle text='Footer' />
					<BasicButton
						backgroundColor={{
							background: localState.config.footer.isActive ? getPrimary() : undefined,
							color: localState.config.footer.isActive ? 'white' : 'black',
						}}
						onClick={() => setLocalState({
							...localState,
							config: {
								...localState.config,
								footer: {
									...localState.config.footer,
									isActive: !localState.config.footer.isActive
								}
							}
						})}
						text={`${localState.config.footer.isActive ? 'Desactivar' : 'Activar'} footer`}
					/>
					<BasicButton
						backgroundColor={{
							background: localState.config.footer.copyright.isActive ? getPrimary() : undefined,
							color: localState.config.footer.copyright.isActive ? 'white' : 'black',
						}}
						onClick={() => setLocalState({
							...localState,
							config: {
								...localState.config,
								footer: {
									...localState.config.footer,
									copyright: {
										...localState.config.footer.copyright,
										isActive: !localState.config.footer.copyright.isActive
									}
								}
							}
						})}
						text={`${localState.config.footer.copyright.isActive ? 'Desactivar' : 'Activar'} copyright`}
					/>
					{localState.config.footer.links
						&& Object.keys(localState.config.footer.links)
							.filter(key => ![null, undefined].includes(localState.config.footer.links[key]?.isActive))
							.map(key => <BasicButton
								key={key}
								backgroundColor={{
									background: localState.config.footer.links[key]?.isActive ? getPrimary() : undefined,
									color: localState.config.footer.links[key]?.isActive ? 'white' : 'black',
								}}
								onClick={() => setLocalState({
									...localState,
									config: {
										...localState.config,
										footer: {
											...localState.config.footer,
											links: {
												...localState.config.footer.links,
												[key]: {
													...localState.config.footer.links[key],
													isActive: !localState.config.footer.links[key]?.isActive
												}
											}
										}
									}
								})}
								text={`${localState.config.footer.links[key]?.isActive ? 'Desactivar' : 'Activar'} ${key}`}
							/>)
					}

				</div>
				{/* PREVIEW */}
				<div style={{
					height: '100%',
					border: '1px solid black',
					borderRadius: '2px',
					position: 'relative',
					width: '100%',
					overflow: 'hidden'
				}}>
					<div
						style={{
							position: 'absolute',
							zIndex: '2',
							fontSize: '30px',
							color: !close ? 'red' : getSecondary(),
							cursor: 'pointer',
							right: '10px',
							top: '10px'
						}}
					>
						{close ?
							<i className='fas fa-lock-open' onClick={() => setClose(false)}></i>
							: <i className='fas fa-lock' onClick={() => setClose(true)}></i>
						}
					</div>
					<div
						style={{
							height: '100%',
							position: 'absolute',
							zIndex: '1',
							width: close ? '' : '100%'
						}}
					>
					</div>
					<div style={{ height: '100%' }}>
						<Main
							defaultPortal={localState}
							match={{ params: { name: '' } }}
						/>
					</div>
				</div>
			</div >
		</Scrollbar>
	), [localState, close]);

	return (
		<FormRootLayout
			form={renderForm()}
			noScrollLayout={true}
			button={
				<BasicButton
					color='white'
					text={translate.save}
					onClick={() => {
						updateState({
							...localState.config,
						});
					}}
					backgroundColor={{
						backgroundColor: getSecondary(),
						border: `1px solid ${getSecondary()}`,
						boxShadow: 'none',
						color: 'white',
						fontWeight: 'bold'
					}}
				/>
			}
		/>
	);
};

export default ConfigModel;
